<ag-grid-angular
  class="ag-theme-quartz margin-top-med"
  data-testid="email-audit-table"
  [tooltipShowDelay]="0"
  [rowData]="rows"
  (gridReady)="onGridReady($event)"
  (rowClicked)="onRowClicked($event)"
  [columnDefs]="columnDefs"
  domLayout="autoHeight"
  [suppressPaginationPanel]="true"
  overlayNoRowsTemplate="<span>No sent emails to display</span>">
</ag-grid-angular>

<div class="custom-paginator" data-testid="email-audit-paginator">
  <span>{{ fromNumber }}</span> to <span>{{ toNumber }}</span> of <span
  class="margin-right-large" data-testid="email-audit-total-records">{{ totalRecords }}</span>
  <mat-icon (click)="onBtFirst()" [ngClass]="pageNumber <= 1 ? 'disabled' : ''">first_page</mat-icon>
  <mat-icon (click)="onBtPrevious()" [ngClass]="pageNumber <= 1 ? 'disabled' : ''">navigate_before</mat-icon>
  Page <span>{{ pageNumber }}</span> of <span>{{ totalPages }}</span>
  <mat-icon (click)="onBtNext()" [ngClass]="pageNumber >= totalPages ? 'disabled' : ''">navigate_next</mat-icon>
  <mat-icon (click)="onBtLast()" [ngClass]="pageNumber >= totalPages ? 'disabled' : ''">last_page</mat-icon>
</div>
